export default __webpack_public_path__ + "static/MaisonNeue-Book-19a672d55e49b82cef878a9db62a880a.woff2";